import apiWordModule from "@/views/apiWord/index.vue";

export const apiWordRoutes = [
  // api工作台
  {
    path: "/apiWord",
    component: apiWordModule,
    redirect: "/apiWord/api-console",
    meta: {
      title: "apiWord",
    },
    children: [
      {
        path: "/apiWord/api-console",
        name: "api-console",
        component: () => import("@/views/apiWord/api-console/api-console.vue"),
        meta: {
          title: "控制台",
        },
      },
      {
        path: "/apiWord/google-verification",
        name: "google-verification",
        component: () =>
          import("@/views/apiWord/google-verification/google-verification.vue"),
        meta: {
          title: "谷歌验证",
        },
      },
      {
        path: "/apiWord/whitelist-list",
        name: "whitelist-list",
        component: () =>
          import("@/views/apiWord/whitelist-list/whitelist-list.vue"),
        meta: {
          title: "白名单列表",
        },
      },
      {
        path: "/apiWord/transaction-pullback",
        name: "transaction-pullback",
        component: () =>
          import(
            "@/views/apiWord/transaction-pullback/transaction-pullback.vue"
          ),
        meta: {
          title: "交易回调",
        },
      },
      {
        path: "/apiWord/assets-management",
        name: "assets-management",
        component: () =>
          import("@/views/apiWord/assets-management/assets-management.vue"),
        meta: {
          title: "资产管理",
        },
      },
      {
        path: "/apiWord/contract-monitoring",
        name: "contract-monitoring",
        component: () =>
          import("@/views/apiWord/contract-monitoring/contract-monitoring.vue"),
        meta: {
          title: "合约监听",
        },
      },
      {
        path: "/apiWord/currency-list",
        name: "currency-list",
        component: () =>
          import("@/views/apiWord/currency-list/currency-list.vue"),
        meta: {
          title: "币种列表",
        },
      },
      {
        path: "/apiWord/currency-apply",
        name: "currency-apply",
        component: () =>
          import("@/views/apiWord/currency-apply/currency-apply.vue"),
        meta: {
          title: "上币申请",
        },
      },
      {
        path: "/apiWord/currency-record",
        name: "currency-record",
        component: () =>
          import("@/views/apiWord/currency-record/currency-record.vue"),
        meta: {
          title: "上币记录",
        },
      },
      {
        path: "/apiWord/deposit-list",
        name: "deposit-list",
        component: () =>
          import("@/views/apiWord/deposit-list/deposit-list.vue"),
        meta: {
          title: "充币列表",
        },
      },
      {
        path: "/apiWord/coin-audit",
        name: "coin-audit",
        component: () => import("@/views/apiWord/coin-audit/coin-audit.vue"),
        meta: {
          title: "提币审核",
        },
      },
      {
        path: "/apiWord/coin-configuration",
        name: "coin-configuration",
        component: () =>
          import("@/views/apiWord/coin-configuration/coin-configuration.vue"),
        meta: {
          title: "提币配置",
        },
      },
      {
        path: "/apiWord/generated-address",
        name: "generated-address",
        component: () =>
          import("@/views/apiWord/generated-address/generated-address.vue"),
        meta: {
          title: "生成地址",
        },
      },
      {
        path: "/apiWord/wallet-address",
        name: "wallet-address",
        component: () =>
          import("@/views/apiWord/wallet-address/wallet-address.vue"),
        meta: {
          title: "批量生成钱包地址",
        },
      },
    ],
  },
];
